import { makeStyles } from 'src/utils/makeStyles';

const styles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75em',
    width: '512px',
    minHeight: '250px',
    padding: '24px',
  },
  buttons: {
    display: 'flex',
    gap: '10px',
    marginTop: 'auto',
  },
  button: {
    padding: '7px 48px',
  },
});

export const opportunityApplyFormStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    maxWidth: '900px',
    padding: 3,
  },
  buttons: {
    display: 'flex',
    gap: 1,
  },
});

export default styles;
